import type { AutocompleteData } from "@color-finder/color-finder-api/models";
import { ColorSearchAutocomplete } from "components/input/colorSearchAutocomplete/ColorSearchAutocomplete";
import type { FilterEntry, FilterType } from "hooks/filters";
import { type Dispatch, type FC, useMemo } from "react";

export interface NumberFilterProps {
  value?: Array<AutocompleteData>;
  onChange?: Dispatch<Array<AutocompleteData>>;
  brands?: Array<AutocompleteData>;
  gradeProperties?: Array<AutocompleteData>;
  t: (key: string) => string;
}

export const NumberFilter: FC<NumberFilterProps> = ({
  value = [],
  onChange,
  brands,
  gradeProperties,
  t,
}) => {
  const filters: Array<FilterEntry> = useMemo(
    () =>
      [
        {
          type: "brand" as FilterType,
          value: brands,
        },
        {
          type: "gradeProperty" as FilterType,
          value: gradeProperties,
        },
      ].filter((e) => e.value !== undefined && e.value.length > 0),
    [brands, gradeProperties],
  );

  return (
    <ColorSearchAutocomplete
      label={t("filter_grade_number")}
      example={"2405"}
      type="gradeNumber"
      value={value}
      filters={filters}
      limit={500}
      onChange={onChange}
    />
  );
};
